<span class="flex {{ isPositive ? 'text-success' : 'text-danger' }} items-center font-bold gap-1"
    *ngIf="value !== 0; else zero">
    <span>{{absoluteValue}}%</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none"
        [class.rotate-180]="!isPositive">
        <path
            d="M1.31131 10.5H13.3327C13.4545 10.4996 13.5738 10.466 13.6778 10.4029C13.7819 10.3398 13.8667 10.2494 13.9233 10.1417C13.9798 10.0339 14.0059 9.91271 13.9987 9.79121C13.9915 9.66971 13.9513 9.55248 13.8824 9.45213L7.87167 0.769981C7.62256 0.410006 7.02283 0.410006 6.77305 0.769981L0.762328 9.45213C0.692754 9.55227 0.651954 9.66956 0.644361 9.79127C0.636768 9.91297 0.662673 10.0344 0.719261 10.1424C0.775848 10.2504 0.860955 10.3409 0.965333 10.4039C1.06971 10.467 1.18937 10.5002 1.31131 10.5Z"
            fill="currentColor" />
    </svg>
</span>


<ng-template #zero>
    <span class="text-white">0%</span>
</ng-template>